module.exports = __webpack_public_path__ + "static/media/Lato-LightItalic.4d80ac57.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Lato/Lato-LightItalic.ttf
// module id = 299
// module chunks = 0